import React from 'react';
import { clientRegister, sectors } from '../data/clients';
export function Clients() {
  return <section id="clients" className="bg-paper py-24" data-id="element-49" data-mp="3jkm7136kifaw">
      <div className="mx-auto max-w-[1240px] px-6" data-id="element-50" data-mp="3jn8llmrvlv2m">
        <p className="eyebrow text-green-dark" data-id="element-51" data-mp="3etmaw059w19g">Who We Serve</p>
        <h2 className="mt-5 max-w-2xl font-display text-[34px] font-medium leading-[1.15] tracking-[-0.01em] text-ink sm:text-[42px]" data-id="element-52" data-mp="39vcclgo94kjm">
          Sector experience that runs deep, not wide.
        </h2>
        <div className="double-rule mt-7 w-24 text-ink" aria-hidden="true" data-id="element-53" data-mp="2zx4z57t68kmd" />

        <div className="mt-12 grid border-l border-t border-line sm:grid-cols-2 lg:grid-cols-4" data-id="element-54" data-mp="2zz9cshgvgxzu">
          {sectors.map(sector => <article key={sector.index} className="border-b border-r border-line p-8" data-id="element-55" data-mp="2qx00pn5ygwkc">
              <span className="font-mono text-[11px] text-green-dark" data-id="element-56" data-mp="u3wuhiox87en">{sector.index}</span>
              <h3 className="mt-4 font-display text-[20px] text-ink" data-id="element-57" data-mp="p53r4j3clws7">{sector.name}</h3>
              <p className="mt-3 text-[14px] leading-relaxed text-ink-70" data-id="element-58" data-mp="p394n0cfhwm0">
                {sector.description}
              </p>
            </article>)}
        </div>

        <div className="mt-16 border border-line" data-id="element-59" data-mp="2srp2ml5wk130">
          <div className="flex flex-wrap items-center justify-between gap-2 bg-ink px-6 py-4" data-id="element-60" data-mp="2eqw840flp5zw">
            <h3 className="font-mono text-[11px] uppercase tracking-[0.14em] text-white" data-id="element-61" data-mp="2jp68cpg6mwsd">
              Client Register — Selected Names
            </h3>
            <span className="font-mono text-[11px] text-green-light" data-id="element-62" data-mp="37ftpm1bzmyrl">
              {String(clientRegister.length).padStart(2, '0')} entries
            </span>
          </div>

          <ul className="grid bg-white md:grid-cols-2 lg:grid-cols-3" data-id="element-63" data-mp="2xofkne19p6r2">
            {clientRegister.map((client, i) => <li key={client.name} className={`flex items-baseline justify-between gap-4 border-b border-line/70 px-6 py-4 lg:border-r ${i % 2 === 1 ? 'bg-parchment/40' : ''}`} data-id="element-64" data-mp="32mh5a3ecde4n" data-mpi={i}>
                <span className="text-[14px] text-ink" data-id="element-65" data-mp="8vgvah7gjuyh">{client.name}</span>
                <span className="shrink-0 font-mono text-[10px] uppercase tracking-[0.08em] text-ink-50" data-id="element-66" data-mp="3wdsl3eya0to">
                  {client.location}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}